/** True when the setting or the system asks for less motion: script-driven animations skip. */
export function motionReduced(): boolean {
  return (
    document.documentElement.hasAttribute('data-reduced-motion') ||
    matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

/** A rectangle relative to the OS's screen (`[data-os]`), in CSS pixels. */
export function rectInOs(element: Element): DOMRect | null {
  const root = element.closest('[data-os]')
  if (!root) return null
  const rect = element.getBoundingClientRect()
  const base = root.getBoundingClientRect()
  return new DOMRect(rect.x - base.x, rect.y - base.y, rect.width, rect.height)
}

/** One point in pixels where `element` sits: the OS sets `--pt` on its root. */
export function pointPx(element: Element): number {
  return Number.parseFloat(getComputedStyle(element).getPropertyValue('--pt')) || 1
}
